import { FC, type JSX } from 'react';

import Modal from '@payaca/components/modal/Modal';
import { Task } from '@payaca/types/taskTypes';
import ViewCompleteTaskControl from '../viewCompleteTaskControl/ViewCompleteTaskControl';
import './ViewCompleteTaskModal.sass';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onUpdateTaskCompletionSuccess?: () => void;
  task: Task;
};
const ViewCompleteTaskModal: FC<Props> = ({
  isOpen,
  onClose,
  onUpdateTaskCompletionSuccess,
  task,
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      className="view-complete-task-modal"
      title={task.name}
      onClose={onClose}
      size="xs"
    >
      <ViewCompleteTaskControl
        task={task}
        onUpdateTaskCompletionSuccess={onUpdateTaskCompletionSuccess}
      />
    </Modal>
  );
};
export default ViewCompleteTaskModal;
